'use client';
import { IMovie } from '@/interfaces/movie';
import { useRouter } from 'next/navigation';
import { formatDate } from '@/utils/app-utils';
import Image from 'next/image';
import React from 'react';
import { IoMdCalendar } from 'react-icons/io';
import { LuClock4 } from 'react-icons/lu';

function MovieCardTab({ movie }: { movie: IMovie }) {
  const router = useRouter();
  return (
    <div className="flex gap-x-2 pr-2 mb-3 cursor-pointer">
      <div
        className="h-[110px] w-[70px] relative group"
        onClick={() => {
          router.push(`/phim/${movie.slug}`);
        }}
      >
        <Image
          unoptimized
          quality={100}
          priority
          width={70}
          height={110}
          src={movie.thumb_url ?? 'https://phim.nguonc.com/public/images/Film/145168.jpg'}
          alt=""
          className="object-cover h-full w-full relative z-0"
        />
        <div
          className="absolute h-full w-full top-0 right-0 group-hover:flex items-center justify-center hidden z-10"
          style={{ backgroundColor: 'rgba(255, 255, 255, 0.35)' }}
        >
          <Image
            src={'/images/play-button.png'}
            unoptimized
            quality={100}
            height={30}
            width={30}
            alt="icon play"
          />
        </div>
      </div>
      <div className="flex flex-col justify-between flex-1">
        <div
          className="text-white font-medium text-[13px] max-md:text-[12px] line-clamp-1 hover:text-yellowMain"
          onClick={() => {
            router.push(`/phim/${movie.slug}`);
          }}
        >
          {movie.name}
        </div>
        <div className="text-gray-400 text-[12px] max-md:text-[11px] line-clamp-2">
          {movie.original_name}
        </div>
        <div className="flex gap-x-1 items-center text-slate-400 text-[12px]">
          <LuClock4 size={16} /> {movie.time}
        </div>
        <div className="flex gap-x-1 items-center text-slate-400 text-[12px]">
          <IoMdCalendar size={16} /> {formatDate(movie.created ?? '')}
          <div className="rounded-xl px-2 py-1 text-[10px] bg-redMain text-white font-medium">
            {movie.quality}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MovieCardTab;
